module.exports = __webpack_public_path__ + "img/dance-test-icon2.bb875282.png";